"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.eigsDocs = void 0;
var eigsDocs = {
  name: 'eigs',
  category: 'Matrix',
  syntax: ['eigs(x)'],
  description: 'Calculate the eigenvalues and eigenvectors of a real symmetric matrix',
  examples: ['eigs([[5, 2.3], [2.3, 1]])'],
  seealso: ['inv']
};
exports.eigsDocs = eigsDocs;


//////////////////
// WEBPACK FOOTER
// ./node_modules/mathjs/lib/cjs/expression/embeddedDocs/function/matrix/eigs.js
// module id = omRK
// module chunks = 23